<script setup lang="ts"></script>

<template>
  <div class="saved-insights-empty">
    <img
      src="@/assets/state-empty-saved-insight.svg"
      width="120"
      height="120"
      alt=""
    />
    <div class="c-title-bold--xm">保存済み発想のヒントはありません</div>
    <div class="c-text-regular--m">
      気になる発想のヒントは保存していつでも見返せるようにしましょう。
    </div>
  </div>
</template>

<style lang="scss" scoped>
.saved-insights-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 92px;
  text-align: center;
}
</style>
